export const CONTACT_INFO = {
  phones: {
    informes: "+51 988 645 008",
    ventas: "+51 963 893 725",
    postVenta: "+51 942 318 876",
  },
  email: "proyectos@nea.com.pe",
  whatsapp: {
    number: "51963893725",
    url: "https://wa.me/51963893725",
  },
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
};

export const COMPANY_INFO = {
  name: "NEA Sinergia Proyectos SAC",
  slogan: "Infraestructura Inteligente: Su aliado integral en soluciones técnicas y tecnológicas",
  year: 2026,
  description: "Optimizamos sus operaciones con diseño, implementación y mantenimiento de infraestructuras críticas corporativas e industriales. Resultado garantizado en cada proyecto.",
  aboutTitle: "Especialistas en infraestructura corporativa de alto desempeño",
  aboutText1: "En NEA Sinergia Proyectos SAC, somos un equipo multidisciplinario de especialistas comprometidos con la excelencia técnica. Integramos procesos, tecnología e infraestructura para brindar resultados sólidos a proyectos corporativos de alta exigencia.",
  aboutText2: "Nuestra metodología garantiza la máxima eficiencia operativa, priorizando los estándares de seguridad y calidad en cada obra que ejecutamos.",
  mission: "Proveer soluciones integrales de infraestructura que impulsen el desarrollo y seguridad de nuestros clientes corporativos.",
  vision: "Ser la empresa referente a nivel nacional en ejecución de proyectos tecnológicos y de servicios generales.",
};